import React from 'react';
import PropTypes from 'prop-types';
import styles from './EmptyState.module.css';
import * as FaIcons from 'react-icons/fa';

const EmptyState = ({
  icon,
  title,
  description,
  action,
  className = '',
  ...rest
}) => {
  const containerClasses = [styles.container, className].filter(Boolean).join(' ');

  const defaultIcon = icon || <FaIcons.FaInbox />;

  return (
    <div className={containerClasses} {...rest}>
      <div className={styles.iconWrapper}>{defaultIcon}</div>
      {title && <h3 className={styles.title}>{title}</h3>}
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.node,
  className: PropTypes.string,
};

export default EmptyState;
